// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --mean-pressure-graph-legend-box-size: 12px;
  --mean-pressure-graph-infusion-icon-size: 28px;
}

.comment-wrapper {
  display: flex;
  position: absolute;
  top: 15%;
  min-width: 30%;
  max-width: 50%;
}

.comment-wrapper.comment-on-right {
  right: unset !important;
  margin-right: unset !important;
  margin-left: var(--spacing-small);
}

.comment-wrapper.comment-on-left {
  left: unset !important;
  margin-right: calc(6px + var(--spacing-small)) !important;
  margin-left: unset !important;
}

.infusion-icon {
  position: absolute;
  top: 0;
  margin: var(--spacing-smaller);
  width: var(--mean-pressure-graph-infusion-icon-size);
  height: var(--mean-pressure-graph-infusion-icon-size);
  --icon-color: var(--color-yellow-orange);
  filter: drop-shadow(0 0 var(--shadow-blur-radius-smaller) var(--color-white));
}

:host-context(.dark-theme) .infusion-icon {
  --icon-color: var(--color-yellow);
  filter: none;
}

.infusion-legend {
  position: absolute;
  bottom: var(--spacing-large);
  right: var(--spacing-medium);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: var(--spacing-smallest);
  padding: var(--spacing-smaller) var(--spacing-small);
  border: solid var(--border-width-thin) var(--color-teal-light);
  border-radius: var(--border-radius-small);
  background-color: var(--color-white-semi-opaque);
}

:host-context(.dark-theme) .infusion-legend {
  border-color: var(--color-blue-light);
  background-color: var(--color-blue-semi-opaque);
}

.legend-line {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-smaller);
}

.legend-line::before {
  content: "";
  height: var(--mean-pressure-graph-legend-box-size);
  width: var(--mean-pressure-graph-legend-box-size);
}

.legend-line.plateau::before {
  background-color: var(--color-teal);
}

.legend-line.basal::before {
  background-color: var(--color-grey-medium);
}

:host-context(.dark-theme) .legend-line.basal::before {
  background-color: var(--color-grey-light);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/patient/components/mean-pressure-graph/mean-pressure-graph.component.scss"],"names":[],"mappings":"AAAA;EACE,2CAAA;EACA,8CAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;EACA,8BAAA;EACA,iCAAA;AACF;;AAEA;EACE,sBAAA;EACA,yDAAA;EACA,6BAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,8BAAA;EACA,oDAAA;EACA,qDAAA;EACA,wCAAA;EACA,6EAAA;AACF;;AACA;EACE,iCAAA;EACA,YAAA;AAEF;;AACA;EACE,kBAAA;EACA,4BAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,oDAAA;EACA,8DAAA;EACA,yCAAA;EACA,gDAAA;AAEF;;AACA;EACE,qCAAA;EACA,+CAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;AAEF;;AACA;EACE,WAAA;EACA,kDAAA;EACA,iDAAA;AAEF;;AACA;EACE,mCAAA;AAEF;;AACA;EACE,0CAAA;AAEF;;AACA;EACE,yCAAA;AAEF","sourcesContent":[":host {\n  --mean-pressure-graph-legend-box-size: 12px;\n  --mean-pressure-graph-infusion-icon-size: 28px;\n}\n\n.comment-wrapper {\n  display: flex;\n  position: absolute;\n  top: 15%;\n  min-width: 30%;\n  max-width: 50%;\n}\n\n.comment-wrapper.comment-on-right {\n  right: unset !important;\n  margin-right: unset !important;\n  margin-left: var(--spacing-small);\n}\n\n.comment-wrapper.comment-on-left {\n  left: unset !important;\n  margin-right: calc(6px + var(--spacing-small)) !important;\n  margin-left: unset !important;\n}\n\n.infusion-icon {\n  position: absolute;\n  top: 0;\n  margin: var(--spacing-smaller);\n  width: var(--mean-pressure-graph-infusion-icon-size);\n  height: var(--mean-pressure-graph-infusion-icon-size);\n  --icon-color: var(--color-yellow-orange);\n  filter: drop-shadow(0 0 var(--shadow-blur-radius-smaller) var(--color-white));\n}\n:host-context(.dark-theme) .infusion-icon {\n  --icon-color: var(--color-yellow);\n  filter: none;\n}\n\n.infusion-legend {\n  position: absolute;\n  bottom: var(--spacing-large);\n  right: var(--spacing-medium);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  gap: var(--spacing-smallest);\n  padding: var(--spacing-smaller) var(--spacing-small);\n  border: solid var(--border-width-thin) var(--color-teal-light);\n  border-radius: var(--border-radius-small);\n  background-color: var(--color-white-semi-opaque);\n}\n\n:host-context(.dark-theme) .infusion-legend {\n  border-color: var(--color-blue-light);\n  background-color: var(--color-blue-semi-opaque);\n}\n\n.legend-line {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: var(--spacing-smaller);\n}\n\n.legend-line::before {\n  content: \"\";\n  height: var(--mean-pressure-graph-legend-box-size);\n  width: var(--mean-pressure-graph-legend-box-size);\n}\n\n.legend-line.plateau::before {\n  background-color: var(--color-teal);\n}\n\n.legend-line.basal::before {\n  background-color: var(--color-grey-medium);\n}\n\n:host-context(.dark-theme) .legend-line.basal::before {\n  background-color: var(--color-grey-light);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
